module.exports = "/images/mm.svg?1e13b8a67a9a964489b474fb5e18a44d";